import {
  type IntegrationNameEnum,
  IntegrationNames,
} from '@webapp/platform/integrations/entities/enums/IntegrationNameEnum'

// Keys are `field_destination` strings from FieldMapping API contract
// (see IntegrationMappingFieldDestination in @webapp/models/enums); values are
// the corresponding source `value` returned by a sourceMappingRegistry build
// step. Consumers in the components layer add type-safe lookup on top.
export type DefaultMappingSourceConfig = Record<string, string>

export type DefaultMappingSourceRegistry = Partial<
  Record<IntegrationNameEnum, DefaultMappingSourceConfig>
>

// `note` (header Memo) defaults to the source the monolith applies when no
// mapping exists, so the pre-selected value matches the legacy behaviour.
const HEADER_MEMO_DEFAULT_SOURCE = 'bill_notes_and_url'

const mergeNetSuiteConfig: DefaultMappingSourceConfig = {
  item_description: 'item_description',
  note: HEADER_MEMO_DEFAULT_SOURCE,
}

const mergeQuickBooksOnlineConfig: DefaultMappingSourceConfig = {
  Description: 'item_description',
  note: HEADER_MEMO_DEFAULT_SOURCE,
}

const mergeSageIntacctConfig: DefaultMappingSourceConfig = {
  note: HEADER_MEMO_DEFAULT_SOURCE,
}

const mergeBusinessCentralConfig: DefaultMappingSourceConfig = {
  note: HEADER_MEMO_DEFAULT_SOURCE,
}

export const defaultMappingSourceRegistry: DefaultMappingSourceRegistry = {
  [IntegrationNames.MERGE_NETSUITE]: mergeNetSuiteConfig,
  [IntegrationNames.MERGE_QUICKBOOKS_ONLINE]: mergeQuickBooksOnlineConfig,
  [IntegrationNames.MERGE_SAGE_INTACCT]: mergeSageIntacctConfig,
  [IntegrationNames.MERGE_BUSINESS_CENTRAL]: mergeBusinessCentralConfig,
}
